import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, Activity, Droplet } from 'lucide-react';
export function SymptomMatrix() {
  return <section className="py-24 bg-[#1a3c2a] text-white relative overflow-hidden" data-id="element-157">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-158">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-159">
          <defs data-id="element-160">
            <pattern id="leaf-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-161">
              <path d="M20 0C10 10 0 20 20 40C40 20 30 10 20 0Z" fill="currentColor" data-id="element-162" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#leaf-pattern)" data-id="element-163" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-165">
          <h2 className="text-3xl md:text-5xl font-bold text-[#c9a84c] mb-4" data-id="element-166">
            The Symptom Matrix System
          </h2>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto" data-id="element-167">
            Skip disease names. Find by symptom in 30 seconds.
          </p>
        </motion.div>

        {/* Matrix Demo */}
        <div className="bg-[#2d5a3d] rounded-2xl p-6 md:p-10 shadow-2xl border border-[#c9a84c]/30" data-id="element-168">
          <div className="grid gap-6" data-id="element-169">
            {/* Row 1 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a3c2a] p-4 rounded-xl flex flex-col md:flex-row items-center gap-4 border border-[#c9a84c]/20" data-id="element-170">
              <div className="flex items-center gap-2 w-full md:w-32 text-[#c9a84c] font-bold" data-id="element-171">
                <Activity className="w-5 h-5" data-id="element-172" />
                Fever?
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-173" />
              <div className="flex-1 text-center md:text-left font-medium text-white" data-id="element-174">
                Ginger Tea (tea/tincture/topical)
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-175" />
              <div className="flex items-center gap-2 text-[#a7f3d0] font-semibold w-full md:w-auto justify-center md:justify-start" data-id="element-176">
                <Clock className="w-4 h-4" data-id="element-177" />
                15-minute relief
              </div>
            </motion.div>

            {/* Row 2 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a3c2a] p-4 rounded-xl flex flex-col md:flex-row items-center gap-4 border border-[#c9a84c]/20" data-id="element-178">
              <div className="flex items-center gap-2 w-full md:w-32 text-[#c9a84c] font-bold" data-id="element-179">
                <Activity className="w-5 h-5" data-id="element-180" />
                Headache?
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-181" />
              <div className="flex-1 text-center md:text-left font-medium text-white" data-id="element-182">
                Peppermint + Willow
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-183" />
              <div className="flex items-center gap-2 text-[#a7f3d0] font-semibold w-full md:w-auto justify-center md:justify-start" data-id="element-184">
                Rotation protocol
              </div>
            </motion.div>

            {/* Row 3 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-[#1a3c2a] p-4 rounded-xl flex flex-col md:flex-row items-center gap-4 border border-[#c9a84c]/20" data-id="element-185">
              <div className="flex items-center gap-2 w-full md:w-32 text-[#c9a84c] font-bold" data-id="element-186">
                <Droplet className="w-5 h-5" data-id="element-187" />
                Bloating?
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-188" />
              <div className="flex-1 text-center md:text-left font-medium text-white" data-id="element-189">
                Fennel protocol
              </div>
              <ArrowRight className="hidden md:block text-gray-400" data-id="element-190" />
              <div className="flex items-center gap-2 text-[#a7f3d0] font-semibold w-full md:w-auto justify-center md:justify-start" data-id="element-191">
                7-day gut reset
              </div>
            </motion.div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-12 space-y-4" data-id="element-192">
          <p className="text-lg text-gray-300" data-id="element-193">
            200+ remedies, 3 prep methods each. Dosage calculator for
            adults/kids/elderly. Contraindications flagged.
          </p>
          <p className="text-2xl font-serif italic text-[#c9a84c]" data-id="element-194">
            Not theory. Your kitchen arsenal.
          </p>
        </motion.div>
      </div>
    </section>;
}